import React from "react";
import { Link } from "react-router-dom";

/**
 * Logo - App logo component
 *
 * @param {Object} props
 * @param {boolean} props.withLink - Wrap in Link component
 * @param {string} props.className - Additional CSS classes
 */
const Logo = ({ withLink = true, className = "" }) => {
  const logo = (
    <span
      className={`text-xl font-bold text-[#4db1e0] hover:text-[#5dc9fc] transition-colors duration-200 ${className}`}
    >
      ELITA Kanban
    </span>
  );

  if (withLink) {
    return (
      <Link to="/" className="hover:opacity-90 transition-opacity duration-200">
        {logo}
      </Link>
    );
  }

  return logo;
};

export default Logo;
